<template>
  <RouterLink class="brand pdf-brand" to="/" aria-label="NITRO-DETEX home">
    <span class="brand-icon" aria-hidden="true">
      <img src="/brand/nitro-detex-lockup-hq.jpg" width="1536" height="420" alt="" />
    </span>
    <span class="brand-lettering">
      <strong class="brand-wordmark"><span>NITRO</span><span class="brand-dash">-</span><span>DETEX</span></strong>
      <span class="brand-descriptor">Industrial Explosives &amp; Initiation Systems</span>
      <span class="brand-motto">A Safer, Stronger Tomorrow</span>
    </span>
  </RouterLink>
</template>
